import appLogo from "assets/images/next_day_access_logo.png";
import AppFrame from "components/AppFrame";
import JobberCallback from "pages/JobberCallback";
import JobberListen360Step1 from "pages/Jobber-Listen360/Step1";
import Error from "pages/Error";
import Login from "pages/Dashboard/Login";
import AuthCallback from "pages/Dashboard/AuthCallback";
import Dashboard from "pages/Dashboard/Dashboard";
import {
    Navigate,
    Outlet,
    Route,
    Routes as ReactRouterRoutes,
} from "react-router-dom";

const Routes = () => {
    return (
        <ReactRouterRoutes>
            <Route element={<AppFrame logo={appLogo} />}>
                <Route index element={<Navigate to="login" />} />
                <Route path="error" element={<Error />} />
                <Route path="jobber-listen360-step1" element={<JobberListen360Step1 />} />
                <Route path="login" element={<Login />} handle={{ routeTitle: "Login" }} />
                <Route element={<ProtectedRoutes />}>
                    <Route path="dashboard" element={<Dashboard />} handle={{ routeTitle: "Dashboard" }} />
                </Route>
            </Route>
            <Route path="jobber/callback" element={<JobberCallback />} />
            <Route path="auth/login/:token" element={<AuthCallback />} />
        </ReactRouterRoutes>
    );
};

const ProtectedRoutes = () => {
    return <Outlet />;
};

export default Routes;
